const backend_url = "https://students-union-backend.vercel.app";

module.exports = { backend_url };
